import React from "react";
import { Button } from "reactstrap";
import CloseIcon from "../../../assets/images/Close.png";
import StarIcon from "../../../assets/images/star.svg";
import WhiteStar from "../../../assets/images/star.png";
import TickIcon from "../../../assets/images/icons/Check.svg";
import avatar from "../../../assets/images/avatar.svg";
import { getGameName } from "../../shared/utils";
import Cross from "../../../assets/images/verboden/cross.png";
import cx from "classnames";
import scoreimg from "../../../assets/images/tw/Score.png";

class PlayerCard extends React.Component {
  delPlayer(data) {
    this.props.delPlayer(data);
  }
  imgError(e) {
    e.target.src = avatar;
  }
  render() {
    const data = this.props;
    const { className } = this.props;

    const roomData = data.roomData;
    let referee = "";
    let guesser = "";
    let highlateUser = false;
    let playerHands = roomData.game_state.player_hands;
    const gameName = getGameName(roomData);

    if (roomData?.game_state) {
      if (roomData?.game_state?.active_player) {
        guesser = roomData.game_state.active_player;
        referee = roomData.game_state.judge_player;
      }
      if (gameName !== "GAH" && roomData?.game_state?.guess) {
        if (roomData.game_state.guess !== "-1") {
          highlateUser = true;
        }
      } else {
        if (gameName === "GAH") {
          if (roomData.game_state?.active_player) {
            highlateUser = true;
          }
        }
      }
    }
    let activePlayerText = "Guesser";
    if (gameName === "GAH") {
      activePlayerText = "Player";
    }

    const highlatedClass =
      data.player_id === guesser && highlateUser ? "highlated" : "";

    let classname = "";
    if (referee === data.player_id) {
      classname = "referee";
    }
    if (guesser === data.player_id) {
      classname = "guesser";
    }
    if (gameName === "GAH" && data.player_id === guesser) {
      classname = "gah";
    }
    if (gameName !== "GAH" && activePlayerText === "Player") {
      classname = "player";
    }

    return (
      <div className={`${gameName === "TW" ? "tw-player-card-wrapper" : ""}`}>
        <div
          className={cx(
            `profileCard ${
              gameName === "GAH" ? "gah" : "tw-player-card"
            } ${highlatedClass}`,
            {
              guesserHighlighted: data.player_id === guesser,
            }
          )}
        >
          <div
            className={cx("d-flex align-items-center tWrapper", classname, {
              countData: data.score > 0,
            })}
          >
            <div className="profileImage">
              <img
                src={data ? data.profile_image : avatar}
                onError={(e) => this.imgError(e)}
                alt={data.display_name}
                className="image"
              />
              {data.clue_PlayCard && (
                <img src={TickIcon} className="tickIcon" alt="" />
              )}
            </div>
            <p className="name" title={data.display_name}>
              {data.display_name}
            </p>
          </div>
          <div className="d-flex align-items-center">
            {data.player_id === guesser && (
              <Button color="green" className="greenBtnsd">
                {
                  // <img
                  //   src={gameName === "GAH" ? WhiteStar : StarIcon}
                  //   alt="star"
                  // />
                }

                {/* {gameName !== "GAH" && (
                  <span className="ml-1">{activePlayerText}</span>
                )} */}
              </Button>
            )}
            {data.score > 0 && <div className="count">{data.score}</div>}
            {referee === data.player_id && (
              // <Button color="green" className="greenBtn">
              //   Referee
              // </Button>
              <img src={scoreimg} className="score-img" alt="score_img"></img>
            )}
            <Button onClick={() => this.delPlayer(data)} className="closeBtn">
              <img src={gameName === "GAH" ? Cross : CloseIcon} alt="close" />
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default PlayerCard;
